import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getFingerprint } from '@telecom/shared/utils/fingerprint';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { OnboardingBrowserRuntimeImpl } from '../../common/services/impls/onboarding-browser-runtime';
import type { DesignFtoOnboardingRuntime } from '../design-fto-onboarding-runtime';

/** Design FTO 游客首次引导 runtime，补充浏览器身份和登录态能力。 */
@injectable()
export class DesignFtoOnboardingRuntimeImpl
    extends OnboardingBrowserRuntimeImpl
    implements DesignFtoOnboardingRuntime {
    /** 获取用于隔离首次展示状态的浏览器稳定指纹。 */
    getIdentityId(): Promise<string> {
        return getFingerprint();
    }

    /** 查询当前浏览器用户是否已经登录。 */
    isUserLogin(): Promise<boolean> {
        return isUserLogin();
    }

}
